<template>
    <div class="d-loader spinner">
        <svg viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle fill="none" stroke-width="8" stroke-linecap="round" :stroke="color" cx="33" cy="33" r="28" />
        </svg>
    </div>
</template>
<script>
export default {
    name: 'DLoader',
    props: {
        color: {
            type: String,
            default: 'black',
        },
    },
}
</script>
<style lang="sass" scoped>
$d: 175.6449737548828

@keyframes spin
    0%
        transform: rotate(0deg)
    100%
        transform: rotate(360deg)

    // $colors: #84EBBD, #4977EC, #F6BB67, #333841
    // $colors: $brand3, $brand1, $ui1

@keyframes strokeanim
    0%
        stroke-dasharray: 1, 300
        stroke-dashoffset: 0
    50%
        stroke-dasharray: 120, 300
        stroke-dashoffset: -$d / 3
    100%
        stroke-dasharray: 120, 300
        stroke-dashoffset: -$d

@keyframes contanim
    100%
        transform: rotate(360deg)

*, *:before, *:after
    box-sizing: border-box
    position: relative

.d-loader
    &.spinner
        width: 42px
        height: 42px
        animation: contanim 2s linear infinite

        svg
            display: block
            margin: 0
            padding: 0
            width: 100%
            height: 100%
            left: 0
            top: 0
            position: absolute
            transform: rotate(-90deg)

            circle
                stroke-width: 6px

            &:nth-child(4)
                z-index: 1

                circle
                    stroke: $gray-1

            @for $i from 1 through 3
                &:nth-child(#{$i})
                    z-index: 2

                    circle
                        stroke-dasharray: 1, 300
                        stroke-dashoffset: 0
                        animation: strokeanim 3s calc(.2s * (#{$i})) ease infinite
                        transform-origin: center center
</style>
